<template>
  <div class="w-half pr-8 overflow-y-scroll det__scroll-ctn pb-12 no-sb scrolling-touch" :class="{'det__scroll-ctn-hasgallery' : hasGallery }">
    <ul class="list-reset uppercase text-left sans">
      <li v-for="sibling in siblings" :key="sibling.title">
        <router-link :to="sibling.uri" class="block w-full bg-grey-darker p-3 mb-4 rounded text-white no-underline tracking-wide text-lg"
          :class="{'bg-red-dark': currentUri === sibling.uri }">{{ sibling.title }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'nav-sidebar',
  props: ['siblings', 'hasGallery'],

  computed: {
    currentUri() {
      return this.$route.path
    },
  }
}
</script>